import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';
import './booth-editor.css';

/** @class ButtonGroupContentData
 * A component to enable editing properties
 * specific to ButtonGroupContents.
 */
export default class ButtonGroupContentData extends Component {
  /** @constructor
    * Creates a new instance of the component
    */
  constructor(props) {
    super(props);
    var state = props.content;
    if(!state.buttons) state.buttons = [{text: 'new button', url: 'new url'}];
    this.state = props.content;
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleButtonDataChange = this.handleButtonDataChange.bind(this);
    this.handleAddButton = this.handleAddButton.bind(this);
    this.handleRemoveButton = this.handleRemoveButton.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  handleButtonDataChange(index, event) {
    const value = event.target.value;
    const name = event.target.name;
    var buttons = this.state.buttons;
    buttons[index][name] = value;
    this.setState({
      buttons: buttons
    });
  }
  handleAddButton() {
    var buttons = this.state.buttons;
    buttons.push({text: 'new button', url: 'new url'});
    this.setState({buttons: buttons});
  }
  handleRemoveButton(index) {
    var buttons = this.state.buttons;
    buttons.splice(index, 1);
    this.setState({buttons: buttons});
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    firebase.database().ref(this.props.dataURL).set(this.state);
  }
  /** @function render
    * Renders the component
    */
  render(){
    var buttonRows = this.state.buttons.map((button, index) => (
      <tr key={index}>
        <td>{index+1}</td>
        <td>
          <input name="text" type="text"
            value={button.text}
            onChange={event => this.handleButtonDataChange(index, event)}
            onBlur={this.handleBlur}
            />
        </td>
        <td>
          <input name="url" type="url"
            value={button.url}
            onChange={event => this.handleButtonDataChange(index, event)}
            onBlur={this.handleBlur}
            />
        </td>
        <td>
          <FontAwesome name="times"
            style={{color: 'red'}}
            onClick={()=>this.handleRemoveButton(index)}/>
        </td>
      </tr>
    ));
    return (
      <div className="dialog-content">
        <h3 className="header">Button Group Content</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text"
            name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="columns">Columns</label><br/>
          <input type="number"
            name="columns"
            value={this.state.columns}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            max="4"
            min="1"
            step="1"
            />
        </div>
        <div className="input-group">
          <label htmlFor="published">
            <input type="checkbox"
              name="published"
              checked={this.state.published}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />&nbsp;
            Published
          </label>
        </div>

        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Button Text</th>
              <th>URL</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {buttonRows}
          </tbody>
        </table>
        <button onClick={this.handleAddButton} style={{marginTop: '1rem', color: 'green'}}>
          <FontAwesome name="plus" />
          Add Button
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-editor/button-group-content-data.js